<template>
  <div ref="root" class="call topPage">
    <div class="slider-outer">
      <div class="slider-inner">
        <template :key="idx" v-for="(slide, idx) in state.slides">
          <img :class="state.current_slide == idx ? 'active' : ''" class="slide-img" v-bind:src="state.slides[idx].img" />
        </template>
      </div>
      <div class="over-ray">
        <div class="top-inner">KEISUKE MIYAMOTO</div>
        <div class="kv_in_content">
          <div class="kv_in_content-header">
            <h1>宮元 啓介</h1>
            <div class="waku">
              <div class="twitter">
                <a href="https://twitter.com/kick_keikumn" target="_blank"><img class="img_1" src="~@/assets/img/sns/twitter.png" /></a>
              </div>
              <div class="instagram">
                <a href="https://www.instagram.com/k.m.1216" target="_blank"><img class="img_1" src="~@/assets/img/sns/Instagram.png" /></a>
              </div>
            </div>
          </div>

          <p class="txt">
            日本のキックボクサー。『THECYCLONE』と称されるヴァリエーション豊かな飛び後ろ回し蹴りや三日月蹴りなど華麗な蹴り技が武器である。前WBCムエタイ・インターナショナル・スーパーバンタム級王者、現WPMF世界スーパーバンタム級王者。
          </p>
        </div>
      </div>
    </div>

    <div class="l_primaryContent">
      <!-- Head-->
      <section class="TopPageHead l_primaryBox fvArea">
        <div></div>

        <div class="container">
          <div id="timeline">
            <div class="timeline-item fade-right">
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <h2>2008</h2>
                <p>
                  第3回アジア国際ジュニア空手道選手権大会 高校男子軽・中量級 優勝<br />
                  第7回全国ジュニア空手道選手権大会 高校男子軽量級 優勝<br />
                  第3回東北極真カップ空手道選手権大会 中学男子重量級 優勝<br />
                  第4回オールジャパンジュニア空手道選手権大会 中学男子軽・中量級 優勝<br />
                  第2回全関東空手道選手権大会 中学男子-65kg級 優勝<br />
                  第23回全国少年少女空手道選手権大会 中学男子重軽量級 優勝<br />
                  <br />
                </p>
              </div>
            </div>

            <div class="timeline-item fade-left">
              <div class="timeline-icon"></div>
              <div class="timeline-content right">
                <h2>2009</h2>
                <p>
                  2009 第10回アマキック全日本選手権大会フェザー級 優勝、最優秀選手賞<br />
                  K-1甲子園2009 関東地区 Bブロック 王者<br />
                  JAKF（アマ）18戦17勝（4KO）1分<br />
                </p>

                <img class="top-inner-img" src="~@/assets/img/trainers/NO1/4.jpg" />
              </div>
            </div>

            <div class="timeline-item fade-right">
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <h2>2010</h2>
                <p>マーシャルアーツ日本キックボクシング連盟 2010年 バンタム級 新人王</p>
              </div>
            </div>

            <div class="timeline-item fade-left">
              <div class="timeline-icon"></div>
              <div class="timeline-content right">
                <h2>2012</h2>
                <p>
                  第2代MA日本ーパーバンタム級王者<br />
                  WBCムエタイ・インターナショナル・スーパーバンタム級王者<br />
                  第4代WBCムエタイ日本統一スーパーバンタム級王者
                </p>
              </div>
            </div>

            <div class="timeline-item fade-right">
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <h2>2013</h2>
                <p>
                  INNOVATION日本フェザー級王者<br />
                  初代INNOVATION日本スーパーバンタム級王者
                </p>
              </div>
            </div>

            <div class="timeline-item fade-left">
              <div class="timeline-icon"></div>
              <div class="timeline-content right">
                <h2>2015</h2>
                <p>WPMF世界スーパーバンタム級王者</p>
                <img class="top-inner-img" src="~@/assets/img/trainers/NO1/5.jpg" />
              </div>
            </div>

            <div class="timeline-item fade-right">
              <div class="timeline-icon"></div>
              <div class="timeline-content">
                <h2>2022</h2>
                <p>現役引退</p>
                <img class="top-inner-img" src="~@/assets/img/trainers/NO1/6.jpg" />
              </div>
            </div>

            <div class="timeline-item fade-left">
              <div class="timeline-icon"></div>
              <div class="timeline-content right">
                <h2>2023</h2>
                <p>サイクロンジム オープン</p>
                <img class="top-inner-img" src="~@/assets/img/trainers/NO1/7.jpg" />
              </div>
            </div>
          </div>
        </div>
        <div class="price-button">
          <div class="button-wrap">
            <div class="button">
              <router-link to="/#staff" @click="onTapReturnButton">
                <div class="icon-arrow-left"></div>
                戻る
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted, onUpdated, computed } from 'vue'
import IScroll from 'iscroll'
import dayjs from 'dayjs'
import { useApplicationStore } from '@/store/modules/applicationModule'

interface State {
  iScrollObj: null | IScroll
  slides: any
  current_slide: any
  visible: any
}

export default defineComponent({
  components: {},
  setup() {
    const ApplicationStore = useApplicationStore()
    const root = ref(null)
    const state = reactive<State>({
      iScrollObj: null,
      slides: [{ img: require('@/assets/img/trainers/NO1/1.jpg') }, { img: require('@/assets/img/trainers/NO1/2.jpg') }, { img: require('@/assets/img/trainers/NO1/3.jpg') }],
      current_slide: null,
      visible: true,
    })

    const shouldShowTopPanel = computed(() => ApplicationStore.getShouldShowTopPanel)

    const myFunc5 = function () {
      const target = document.getElementsByClassName('fade-right')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    const myFunc = function () {
      const target = document.getElementsByClassName('fade-left')
      const position = Math.floor(window.innerHeight * 0.75)

      for (let i = 0; i < target.length; i++) {
        let offsetTop = Math.floor(target[i].getBoundingClientRect().top)
        let offsetBottom = Math.floor(target[i].getBoundingClientRect().bottom)

        if (offsetTop < position) {
          target[i].classList.add('active')
        } else {
          target[i].classList.remove('active')
        }

        if (offsetBottom < 0) {
          target[i].classList.remove('active')
        }
      }
    }

    window.addEventListener('scroll', async function () {
      myFunc(), false
      myFunc5(), false
    })

    const onTapReturnButton = () => {
      state.visible = false
    }

    setTimeout(() => {
      if (state.current_slide === null) {
        state.current_slide = 2
      }
    }, 300)

    // 実行したい処理
    setInterval(() => {
      state.current_slide = state.current_slide < state.slides.length - 1 ? state.current_slide + 1 : 0
      // console.log(state.current_slide)
    }, 8000)

    return {
      root,
      state,
      onTapReturnButton,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~@/assets/css/colors';

.call {
  background-color: #fff;
}

.slider-outer {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0 auto 20px;
}

.slider-inner {
  position: relative;
  width: 100%;
  height: 90%;
  overflow: hidden;
}

.slide-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  opacity: 0;
  transform: scale(1.1);

  &.active {
    transition: transform 8000ms ease-out 0s, opacity 800ms ease 0s;
    opacity: 1;
    transform: scale(1.2);
  }
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 800ms ease 0s;
  opacity: 1;
}

.fade-enter-active {
  transition: transform 8000ms ease-out 0s;
  transform: scale(1.2);
}

.fade-enter-to {
  transform: scale(1.1);
}

.over-ray {
  width: 100%;
  height: 90%;
  background-color: rgba($color: #000000, $alpha: 0.5);
  position: absolute;
  top: 0;
}

.title-wrap {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  flex-direction: column;
  margin-bottom: 120px;
  font-weight: 900;

  & h1 {
    font-size: 4rem;
    font-weight: 900;
    line-height: 1;
  }

  & h2 {
    font-size: 3rem;
    font-weight: 900;
  }
}

#title {
  text-align: center;
}

.top-inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #fff;
  font-size: 8rem;
  font-family: 'Shippori Mincho', serif;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-align: center;

  &-img {
    max-width: 600px;
    width: 100%;
  }
}

.l_noiseMotion,
.l_videoBox .l_video {
  // height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.l_videoBox .l_video {
  object-fit: cover;
  position: relative;
}

.TopPageVideo {
  left: 28.6%;
  position: fixed;
  top: 5vw;
  width: 67%;
  z-index: 1;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &.l_videoBox .l_videoBoxInner {
      height: 0;
      overflow: hidden;
      padding-bottom: 100%;
      position: relative;
      width: 100%;
    }

    &.l_videoBox .l_video {
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: auto;
    }
  }
}

.l_videoBox {
  overflow: hidden;
}

.l_videoBox .l_videoBoxInner {
  height: 0;
  overflow: hidden;
  padding-bottom: 53%;
  position: relative;
  width: 100%;
}

.l_noiseMotion {
  animation: noise 0.2s steps(1) infinite;
  backface-visibility: hidden;
  background: #010719 url('~@/assets/img/video/noise_bg.png') repeat 0 0;
  background-repeat: repeat;
  background-size: 200px 200px;
  bottom: 0;
  opacity: 0.5;
  overflow: hidden;
  pointer-events: none;
  right: 0;
  transform-origin: 50% 50%;
  will-change: transform;
  z-index: 2;
}

.TopPage .l_primaryContent {
  position: relative;
  z-index: 3;
}

.TopPageHead {
  position: relative;
  padding-bottom: 140px;
  // pointer-events: none;
  z-index: 2;
  padding-top: 100px;
}

.l_primaryBox {
  padding-left: 4.4%;
  padding-right: 4.4%;
}

.TopPageHead .TopPageHeadTitle {
  position: relative;
  width: 60%;
  z-index: 2;
}

.TopPageHead .TopPageHeadTitle .TopPageHeadTitleRead {
  bottom: 0;
  color: #fff;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.02em;
  position: absolute;
  right: -12vw;
}

.head-title {
  color: #fff;
  font-size: 8rem;
  font-family: 'Shippori Mincho', serif;
}

.head-subtitle-wrap {
  margin-top: 120px;
  width: 100%;
  position: relative;

  & .price-item-des-wrap-one .price-item-des {
    margin-top: 0;
  }

  & .price-item-des-wrap {
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    & .price-item-des-title {
      font-size: 30px;
    }

    & .arrow-bottom {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin: 0 40px;
      border-bottom: 4px solid #fff;
      border-right: 4px solid #fff;
      transform: translateX(-100%) rotate(-45deg);
      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        transform: translateX(0) rotate(-45deg);
        opacity: 1;
      }
    }
  }
}

.head-subtitle-bottomwrap {
  display: flex;
  flex-direction: column;
  align-items: center;

  .head-subtitle {
    text-align: center;
    color: #fff;
    font-size: 6rem;
  }
}

.head-subtitle {
  color: #fff;
  background-color: $sub;
  display: inline-block;
  padding: 5px;
  font-size: 4rem;
  font-weight: 900;
}

.js-inViewAct {
  animation: inViewActKey 1s;
  animation-delay: 0s;
  animation-fill-mode: forwards;
  animation-timing-function: cubic-bezier(0.4, 0.005, 0.14, 1);
  backface-visibility: hidden;
  transform-origin: left top;
  will-change: transform;
}

.WhiteBack {
  background-color: #fff;
  position: relative;
  z-index: 3;
}

.BlackBack {
  // background-color: $main;
  color: #fff;
  position: relative;
  z-index: 3;
}

.price-item {
  display: flex;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 40px;
  flex-direction: column;
  width: 33%;

  &-wrap {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  &-middle {
    &-wrap {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
  }
}

.price-item-title {
  width: 100%;
  height: 70px;
  margin: 15px 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 70px;
  background: $main;
  position: relative;
  color: #fff;
}

.price-item-des {
  &-numtext {
    font-size: 50px;
    margin-right: -3px;
    position: relative;

    &::after {
      position: absolute;
      bottom: calc(50% - 5px);
      left: 0;
      content: '';
      width: 100%;
      height: 5px;
      background: $sub;
      transform: scale(0, 1);
      transform-origin: left top;
      transition: transform 0.5s;
    }

    &.active::after {
      transform: scale(1, 1);
    }
  }
}

.price-item-des {
  &-numtext2 {
    font-size: 50px;
    margin-right: -3px;
    position: relative;
    color: $sub;

    &-wrap {
      position: relative;

      opacity: 0;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &.active {
        opacity: 1;
      }
    }

    &-tag {
      position: absolute;
      width: 100px;
      background: $sub;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      top: 0;
      left: -105px;
      font-size: 1.2rem;
      transform: rotate(-5deg);
    }
  }

  &-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    &-one {
      .price-item-des {
        margin-top: 70px;
      }
    }
  }
}

.arrow-bottom {
  display: inline-block;
  width: 18px;
  height: 18px;
  margin: auto 10px 20px;
  border-bottom: 4px solid #000;
  border-right: 4px solid #000;
  transform: translateY(-100%) rotate(45deg);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateY(0) rotate(45deg);
    opacity: 1;
  }
}

.contact-button {
  width: 300px;
  height: 100px;
  border-radius: 15px;
  background: #ffffff;
  box-shadow: 5px -5px 47px #b0b0b0, -5px 5px 47px #ffffff;

  // &-wrap {
  //   border-radius: 21px;
  //     background: #ffffff;
  //     box-shadow: inset 5px 5px 10px #666666,
  //       inset -5px -5px 10px #ffffff;
  // }
}

.TopPageService {
}

.fade-right {
  transform: translateX(-100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-left {
  transform: translateX(100%);
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    transform: translateX(0);
    opacity: 1;
  }
}

.fade-in {
  opacity: 0;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  &.active {
    opacity: 1;
  }
}

.recommend {
  &- {
    &wrap {
      margin-top: 160px;
      padding-left: 23%;
      padding-top: 160px;
      font-weight: 900;
      color: #fff;
    }

    &title {
      font-family: 'Shippori Mincho', serif;
      font-size: 2rem !important;
      color: #f2f2f2;
    }

    &text {
      font-size: 8rem;
      word-break: keep-all;
    }
  }
}

.member-wrap {
  display: flex;

  & li {
    max-width: 320px;

    img {
      transition: 1s all;
    }

    &:hover {
      img {
        transform: scale(1.2, 1.2);
        transition: 1s all;
      }

      & .icon-arrow-left {
        background-color: $sub;
      }
    }

    & .pic {
      height: 100%;
      overflow: hidden;
    }

    & .tmName {
      position: relative;
      display: block;
      font-size: 1.2rem;
      line-height: 2em;
      letter-spacing: 0.04em;
      background-color: #fff;
      text-align: center;
      color: #333;
      width: 85%;
      z-index: 99999;
      padding: 5% 0;
      margin: -20px auto 0;
    }

    & .icon-arrow-left {
      position: absolute;
      right: 15px;
      top: -15px;
      width: 30px;
      height: 30px;
      background-color: #000;
      -webkit-transition: all 1s;
      -moz-transition: all 1s;
      -ms-transition: all 1s;
      -o-transition: all 1s;
      transition: all 1s;

      &:after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        margin-left: -7.5px;
        margin-top: 7.5px;
        border-bottom: 2px solid #fff;
        border-right: 2px solid #fff;
        transform: rotate(-45deg);
      }
    }

    & .name {
      position: relative;
      display: block;
      font-size: 1.4rem;
      font-weight: 700;
    }

    & .home {
      position: relative;
      display: block;
    }

    & .kinds {
      display: block;
      margin-top: 5px;
      width: 100%;
    }
  }
}

.button {
  position: relative;
  font-family: 'Shippori Mincho', serif;
  display: flex;
  font-size: 3rem;
  font-weight: bold;
  line-height: 2em;
  letter-spacing: 0.04em;
  background-color: #fff;
  text-align: center;
  color: $main;
  max-width: 300px;
  width: 100%;
  z-index: 99999;
  height: 100%;
  justify-content: center;
  align-items: center;

  &:hover {
    & .icon-arrow-left {
      background-color: $sub !important;
    }
  }

  &-wrap {
    height: 100px;
    margin: 40px 0 80px;

    &.black {
      .button {
        background-color: $main;
        color: #fff;
      }

      .icon-arrow-left {
        background-color: #fff;

        &:after {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-left: -7.5px;
          margin-top: 7.5px;
          border-bottom: 2px solid $main;
          border-right: 2px solid $main;
          transform: rotate(-45deg);
        }
      }
    }
  }
}

.footer {
  height: 200px;
  background-color: #000;

  section {
    height: 100%;
    background-color: #000;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  &-title {
    font-size: 2.4rem;
    font-weight: bold;
    letter-spacing: 0.05em;
    font-family: 'Shippori Mincho', serif;
  }

  &-copy {
    font-size: 1.4rem;
    font-weight: bold;
    letter-spacing: 0.05em;
    font-family: 'Shippori Mincho', serif;
    margin-bottom: 40px;
  }
}

@import 'https://fonts.googleapis.com/css?family=Dosis:300,400,500,600,700';

// Variables
$bg-body: #f9f9f9;

$red: $sub;
$blue: #2b2e48;
$primary-color: $red;
$secondary-color: $blue;

// Typography
$base-font: helvetica, arial, tahoma, verdana;
$base-font-title: 'Dosis', arial, tahoma, verdana;

$base-font-color: #726f77;

// Timeline
$timeline-color: $primary-color;

// Mixins and Placeholders
%clearfix {
  &:after,
  &:before {
    content: '';
    display: block;
    width: 100%;
    clear: both;
  }
}

@mixin prefix($prop, $val) {
  @each $prefix in '-webkit-', '-moz-', '-ms-', '' {
    #{$prefix}#{$prop}: $val;
  }
}

*,
*:before,
*:after {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
}

body,
html {
  height: 100%;
}

body {
  background: $bg-body;
  background-size: cover;
  margin: 0;
  padding: 0;
  font-family: $base-font;
  line-height: 20px;
  font-size: 14px;
  color: $base-font-color;
}

img {
  max-width: 100%;
}

a {
  text-decoration: none;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

h1,
h2,
h3,
h4 {
  font: {
    family: $base-font-title;
    weight: 500;
  }
}

.project-name {
  text-align: center;
  padding: 10px 0;
}

// Header
header {
  background: $secondary-color;
  padding: 10px;
  @include prefix(box-shadow, 0 3px 3px rgba(0, 0, 0, 0.05));
  @extend %clearfix;

  .logo {
    color: $primary-color;
    float: left;

    font: {
      family: $base-font-title;
      size: 22px;
      weight: 500;
    }

    > span {
      color: lighten($primary-color, 20%);
      font-weight: 300;
    }
  }

  .social {
    float: right;

    .btn {
      font-family: 'Dosis';
      font-size: 14px;
      margin: 10px 5px;
    }
  }
}

// Timeline
#timeline {
  width: 100%;
  margin: 30px auto;
  position: relative;
  padding: 0 10px;
  @include prefix(transition, all 0.4s ease);

  &:before {
    content: '';
    width: 3px;
    height: 100%;
    background: $timeline-color;
    left: 50%;
    top: 0;
    position: absolute;
  }

  &:after {
    content: '';
    clear: both;
    display: table;
    width: 100%;
  }

  .timeline-item {
    margin-bottom: 50px;
    position: relative;
    @extend %clearfix;

    .timeline-icon {
      background: $timeline-color;
      width: 50px;
      height: 50px;
      position: absolute;
      top: 0;
      left: 50%;
      overflow: hidden;
      margin-left: -23px;
      @include prefix(border-radius, 50%);

      svg {
        position: relative;
        top: 14px;
        left: 14px;
      }
    }

    .timeline-content {
      width: 45%;
      padding: 20px;
      font-family: 'Shippori Mincho', serif;
      letter-spacing: 0.04em;
      @include prefix(box-shadow, -1px 19px 31px -17px #777777);
      @include prefix(border-radius, 5px);
      @include prefix(transition, all 0.3s ease);

      h2 {
        padding: 15px;
        // background: $timeline-color;
        margin: -20px -20px 0 -20px;
        font-weight: 300;
        @include prefix(border-radius, 3px 3px 0 0);
        font-family: 'Shippori Mincho', serif;
        letter-spacing: 0.1em;
      }

      // &:before {
      //   content: '';
      //   position: absolute;
      //   left: 45%;
      //   top: 20px;
      //   width: 0;
      //   height: 0;
      //   border-top: 7px solid transparent;
      //   border-bottom: 7px solid transparent;
      //   border-left: 7px solid $timeline-color;
      // }

      &.right {
        float: right;

        // &:before {
        //   content: '';
        //   right: 45%;
        //   left: inherit;
        //   border-left: 0;
        //   border-right: 7px solid $timeline-color;
        // }
      }
    }
  }
}

// Buttons
.btn {
  padding: 5px 15px;
  text-decoration: none;
  background: transparent;
  border: 2px solid lighten($primary-color, 10%);
  color: lighten($primary-color, 10%);
  display: inline-block;
  position: relative;
  text-transform: uppercase;
  font-size: 12px;
  @include prefix(border-radius, 5px);
  @include prefix(transition, background 0.3s ease);
  @include prefix(box-shadow, 2px 2px 0 lighten($primary-color, 10%));

  &:hover {
    box-shadow: none;
    top: 2px;
    left: 2px;
    @include prefix(box-shadow, 2px 2px 0 transparent);
  }
}

@media screen and (max-width: 768px) {
  .top-inner {
    font-size: 5rem;
  }

  #timeline {
    margin: 30px;
    padding: 0px;
    width: 90%;

    &:before {
      left: 0;
    }

    .timeline-item {
      .timeline-content {
        width: 90%;
        float: right;

        &:before,
        &.right:before {
          left: 10%;
          margin-left: -6px;
          border-left: 0;
          border-right: 7px solid $timeline-color;
        }
      }

      .timeline-icon {
        left: 0;
      }
    }
  }
}

.kv_in_content {
  position: absolute;
  z-index: 10;
  background-color: #fff;
  display: block;
  margin-right: 7.5%;
  margin-left: 7.5%;
  text-align: left;
  bottom: 0;
  box-shadow: -1px 19px 31px -17px #777777;
  font-family: 'Shippori Mincho', serif;

  @media (orientation: landscape) {
    bottom: -160px;
  }

  &-header {
    display: flex;
    align-items: center;
    padding: 40px 7.5% 0;
  }

  & h1 {
    font-size: 2.1rem;
    line-height: 1.6em;
    margin: 0;
    margin-right: 20px;
    font-family: 'Shippori Mincho', serif;
  }

  & p {
    margin: 0;
    padding: 25px 7.5% 40px;
    font-size: 1.4rem;
    line-height: 2em;
    letter-spacing: 0.04em;
    z-index: 3;
  }
}

.waku {
  display: flex;

  & div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border: 1px solid;
    border-radius: 50%;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;
    margin-right: 15px;

    &.instagram:hover {
      border: 1px solid #cf2e92;
    }

    &.twitter:hover {
      border: 1px solid #1da1f2;
    }

    & a {
      display: flex;
    }
  }

  & img {
    max-width: 15px;
    height: auto;
    width: 100%;
    -webkit-filter: grayscale(1);
    filter: $main;
    filter: grayscale(1);
  }

  & img:hover {
    -webkit-filter: grayscale(0);
    filter: none;
    filter: grayscale(0);
  }
}

.button {
  font-family: 'Shippori Mincho', serif;
  position: relative;
  display: flex;
  font-size: 2rem;
  line-height: 2em;
  letter-spacing: 0.04em;
  background-color: #ada554;
  text-align: center;
  color: #fff;
  max-width: 300px;
  width: 100%;
  z-index: 99999;
  height: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  -webkit-transition: all 1s;
  -moz-transition: all 1s;
  -ms-transition: all 1s;
  -o-transition: all 1s;
  transition: all 1s;

  a {
    color: #fff;
    font-size: 1.8rem;
    line-height: 2em;
    width: 100%;
  }

  &:hover {
    letter-spacing: 0.24em;
    & .icon-arrow-left {
      transform: translateX(3px);
    }
  }

  &-wrap {
    height: 70px;
    margin: 120px 0 80px;

    &.black {
      .button {
        background-color: $main;
        color: #fff;
      }

      .icon-arrow-left {
        background-color: #fff;

        &:hover {
          &:after {
            transform: translateX(-18px) rotate(-45deg);
          }
        }

        &:after {
          content: '';
          display: inline-block;
          width: 15px;
          height: 15px;
          margin-left: -7.5px;
          margin-top: 7.5px;
          border-bottom: 2px solid $main;
          border-right: 2px solid $main;
          transform: rotate(-45deg);
          -webkit-transition: all 1s;
          -moz-transition: all 1s;
          -ms-transition: all 1s;
          -o-transition: all 1s;
          transition: all 1s;
        }
      }
    }
  }

  & .icon-arrow-left {
    position: absolute;
    left: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    -webkit-transition: all 1s;
    -moz-transition: all 1s;
    -ms-transition: all 1s;
    -o-transition: all 1s;
    transition: all 1s;

    &:after {
      content: '';
      display: inline-block;
      width: 15px;
      height: 15px;
      margin-left: -7.5px;
      margin-top: 7.5px;
      border-bottom: 2px solid #fff;
      border-right: 2px solid #fff;
      transform: rotate(135deg);
    }
  }
}

@media screen and (max-width: 600px) {
  .kv_in_content {
    bottom: -160px;
  }
}
</style>
